/* eslint-disable react/prop-types */
import React from 'react'

export default function HomePlate({ pitcherPerspective }) {
    if (pitcherPerspective) {
        return (
            <>
                <defs>
                    <style>{`.e{fill:#eaeaea;stroke:#d6d6d6;stroke-miterlimit:10;}`}</style>
                </defs>
                <g id="a" />
                {/* This sucks, hardcoding for now */}
                <g id="b" transform="translate(190, 435)">
                    <g id="c">
                        <path
                            id="d"
                            className="e"
                            d="M15.65,12.74S58.68,.52,58.68,.52l44.2,12.22,16.74,36H.75L15.65,12.74Z"
                        />
                    </g>
                </g>
            </>
        )
    }

    return (
        <>
            <defs>
                <style>{`.e{fill:#eaeaea;stroke:#d6d6d6;stroke-miterlimit:10;}`}</style>
            </defs>
            <g id="a" />
            {/* This sucks, hardcoding for now */}
            <g id="b" transform="translate(190, 400) scale(1.13, 0.954)">
                <g id="c">
                    <path
                        id="d"
                        className="e"
                        d="M.5,33.51s52.15,17.56,52.15,17.56l53.21-17.56L91.81,.85,13.85,.5,.5,33.51Z"
                    />
                </g>
            </g>
        </>
    )
}
